import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { optAllYesNo } from "@bookings/BookingSearch/utils";
import { ToggleBtnFilter } from "./_common/toggle-btn-filter";

type Option = { label: string; value: string | null };

export type GroupInvoicingFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const GroupInvoicingFilter = ({
  label,
  options,
  ...props
}: GroupInvoicingFilterProps) => {
  const title = label ?? locale.bookingSupportChecks.groupInvoicing;

  return <ToggleBtnFilter label={title} options={optAllYesNo} {...props} />;
};
